export const defaultBarColor = "#1f83e0";
export const comparedBarColor = "#f72f19";
